import { styled } from '@mui/material/styles';
import { OutlinedInput } from '@mui/material';
export const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
    "width": '100%',
    "height": 36,
    "lineHeight": '20px',
    "fontSize": '14px',
    "background": theme.palette.background.default,
    '& fieldset': {
        borderWidth: `1px !important`,
        borderColor: `${theme.palette.borderGrey} !important`
    },
    '&:hover': {
        borderColor: theme.palette.borderGrey
    },
    '&.Mui-focused': {
        "background": theme.palette.primary.lightest,
        "borderColor": `${theme.palette.primary.main} !important`,
        '& fieldset': {
            borderWidth: `1px !important`,
            borderColor: `${theme.palette.primary.main} !important`
        }
    },
    '&.Mui-disabled': {
        opacity: 0.5,
        background: theme.palette.background.default,
    }
}));
